<script>
import { countWords } from "../utils/wordCounter";
const COUNT_TYPE = {
    char: "char",
    word: "word"
};

const EMPTY_INPUT = document.createElement("input");
const EMPTY_TEXTAREA = document.createElement("textarea");
const excludeAttrs = ["value"];
function collectAttributesFor(elType, props) {
    const typeInstant = elType == "input" ? EMPTY_INPUT : EMPTY_TEXTAREA;
    let attributes = {};
    for (const attr in props) {
        if (
            props[attr] != null &&
            excludeAttrs.indexOf(attr) < 0 &&
            attr in typeInstant
        ) {
            attributes[attr] = "" + props[attr];
        }
    }
    return attributes;
}

export default {
    props: {
        value: {
            type: String
        },
        inputProps: {
            type: Object,
            default() {
                return {
                    type: "text"
                };
            }
        },
        countType: {
            type: String,
            default: COUNT_TYPE.char
        },
        max: {
            type: Number
        }
    },
    data() {
        return {
            count: 0
        };
    },
    render(createElement) {
        let inputEl = null;
        const self = this;

        const props = { value: self.value, ...this.inputProps };
        const inputType = this.inputProps.type || "text";
        if (inputType == "text") {
            const attrs = collectAttributesFor("input", props);
            inputEl = createElement(
                "el-input",
                {
                    attrs,
                    props,
                    on: {
                        input: self.handleTextChanged
                    }
                },
                [
                    createElement(
                        "span",
                        {
                            class: {
                                "el-input__icon": true,
                                "count-input__symbol": true,
                                "count-input__symbol--beyond":
                                    self.count > self.max
                            },
                            slot: "suffix"
                        },
                        [`${self.count}/${self.max}`]
                    )
                ]
            );
        } else {
            const attrs = collectAttributesFor("textarea", props);
            inputEl = createElement("el-input", {
                attrs,
                props,
                on: {
                    input: self.handleTextChanged
                }
            });
        }

        if (inputType == "text") {
            return createElement(
                "div",
                { class: "component--input-with-counter" },
                [inputEl]
            );
        } else {
            return createElement(
                "div",
                { class: "component--input-with-counter" },
                [
                    inputEl,
                    createElement("div", { class: "count-input__footer" }, [
                        createElement(
                            "span",
                            {
                                class:
                                    self.count > self.max
                                        ? "beyond-length"
                                        : null
                            },
                            [`${this.count}/${this.max}`]
                        )
                    ])
                ]
            );
        }
    },
    methods: {
        _calculateCount(txt) {
            if (!txt) return 0;

            return this.countType == COUNT_TYPE.char
                ? txt.trim().length
                : countWords(txt);
        },
        handleTextChanged(txt) {
            this.count = this._calculateCount(txt);
            this.$emit("input", txt);
        }
    },
    watch: {
        value:{
            handler(newValue) {
               this.count = this._calculateCount(newValue);
            },
            immediate:true
        }
    },
    mounted() {
        this._calculateCount(this.value);
    }
};
</script>

<style lang="scss">
.component--input-with-counter {
    position: relative;

    .count-input__footer {
        position: absolute;
        bottom: 4px;
        right: 9px;
        border-radius: 4px;
        text-align: right;
        color: #909399;
        font-size: 12px;
        line-height: 12px;

        .beyond-length {
            color: #f56c6c;
        }
    }

    .count-input__symbol {
        font-size: 12px;
        line-height: 12px;
    }

    .count-input__symbol--beyond {
        color: #f56c6c;
        background: white;
    }

    .el-textarea {
        .el-textarea__inner {
            padding-bottom: 20px;
        }
    }
}
</style>